<template>
  <ErrorPage 
    code="404"
    title="errors.404_title"
    message="errors.404_message"
  />
</template>

<script>
import ErrorPage from "@/layouts/ErrorPage.vue"

export default {
  name: "Error404",
  components: { ErrorPage }
}
</script>
